import { getDatabase, ref, set, get, push, remove } from "firebase/database";
import { getStorage, ref as sRef, uploadBytes,getDownloadURL  } from "firebase/storage";


export async function saveToFirebase(path, data) {
    const database = getDatabase();
    await set(ref(database, path), data);
}


export async function uploadFileToFirebase(file, folder, fileName) {
    try {
        if (isBigFile(file)) {
            alert('حجم الملف يجب ان يكون اقل من 1 ميجا');
            throw new Error('File size exceeds 1 MB limit');
        }

        const storage = getStorage();
        const storageRef = sRef(storage, `${folder}/${fileName}`);
        var snapshot = await uploadBytes(storageRef, file);
        if (snapshot) {
            return await getDownloadURL(snapshot.ref);
        }
        return null;
    } catch (error) {
        console.error('Error uploading file to Firebase Storage:', error);
        throw error;
    }
}

export async function uploadAudioToFirebase(file, folder, fileName) {
    try {
        if (isVeryBigFile(file)) {
            alert('حجم الملف يجب ان يكون اقل من 6 ميجا');
            throw new Error('File size exceeds 6 MB limit');
        }

        const storage = getStorage();
        const storageRef = sRef(storage, `${folder}/${fileName}`);
        var snapshot = await uploadBytes(storageRef, file);
        if (snapshot) {
            return await getDownloadURL(snapshot.ref);
        }
        return null;
    } catch (error) {
        console.error('Error uploading file to Firebase Storage:', error);
        throw error;
    }
}

export async function saveRecentEntry(id, type, title) {
    try {
        const database = getDatabase();
        const recentsRef = ref(database, 'recents');
        
        // Get current recents
        const snapshot = await get(recentsRef);
        let recents = [];
        
        if (snapshot.exists()) {
            recents = Object.values(snapshot.val());
        }
        
        // Add new entry
        const newEntry = {
            id: id,
            type: type,
            title: title,
            timestamp: Date.now()
        };
        
        recents.push(newEntry);
        
        // Sort by timestamp (newest first) to ensure proper ordering
        recents.sort((a, b) => b.timestamp - a.timestamp);
        
        // Keep only the first 7 entries (most recent)
        if (recents.length > 6) {
            recents = recents.slice(0, 6);
        }
        
        // Save back to Firebase
        await set(recentsRef, recents);
        
        return true;
    } catch (error) {
        console.error('Error saving recent entry:', error);
        throw error;
    }
}

export function isBigFile(file){
    const maxSize = 1 * 1024 * 1024; // 1 MB
    return file.size > maxSize;        
}
export function isVeryBigFile(file){
    const maxSize = 6 * 1024 * 1024; // 6 MB
    return file.size > maxSize;        
}
